"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.list.title': 'Kroki Onboardingu',
    'step.list.empty': 'Nie znaleziono kroków',
};
